<template>
  <div class="modal-card">
    <div class="modal-card-head">
      <p class="modal-card-title">Are you still there?</p>
    </div>
    <div class="modal-card-body">
      <p>
        We've not seen any activity from you in a while. If you wish to remain on the page click the button below.
        Taking no action in the next {{Minutes}} minutes will take you back to the dashboard without saving.
      </p>
      <p>
        Are you still working?
      </p>
    </div>
    <div class="modal-card-foot">
      <div>
        <button class="button is-primary" @click="Redirect()">No</button>
        <button class="button is-primary" @click="Close()">Yes</button>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        ttl: 0,
        redirect: '/login',
        timer: undefined
      }
    },
    props: {
      time: Number,
      go: String,
      defaultTime: Number,
      defaultPath: String
    },
    computed: {
      Minutes() {
        return this.ttl / (1000 * 60);
      }
    },
    methods: {
      Close(output) {
        this.KillTimer();
        this.$emit('close', output);
      },
      Redirect() {
        this.KillTimer();
        this.Close(this.redirect);
      },
      KillTimer() {
        if (this.timer !== undefined)
          clearTimeout(this.timer);
      }
    },
    created() {
      this.ttl = this.defaultTime;
      this.redirect = this.defaultPath;
      if (this.time && this.time > 0)
        this.ttl = this.time;
      if (this.go && this.$router.options.routes.some(route => route.path == this.go))
        this.redirect = this.go;

      this.timer = setTimeout(this.Redirect, this.ttl);
    }
  }
</script>
